import TemplateService from "@frontend/services/api/template";
import {extractLayersFromTree, extractTemplatesFromTree} from "@frontend/group/modules/fig-layers/helpers";
import {getUpdatedDataLayoutTemplatesGrid} from "@frontend/group/modules/get-updated-data-layout-templates-grid";
import LayoutService from "@frontend/services/api/layout";
import Route from '@frontend/services/helpers/url';

const ACTION_IMPORT_FROM_PRESELECTED_FIG = 'import-from-preselected-fig';

const MOCK_CONTENT_FOR_GRID = () => $('<div></div>');

const getDataGrid = (newTemplates) => {
  const previews = window.previews || [];
  const oldTemplates = [];

  previews.forEach(({ template, settings: { instance_id, x, y, w, h } }) => {
    oldTemplates.push({
      id: template.id,
      instanceId: instance_id,
      name: template.name,
      width: template.width,
      height: template.height,
      content: MOCK_CONTENT_FOR_GRID(),
      gridData: { x, y, w, h }
    });
  });

  return getUpdatedDataLayoutTemplatesGrid(oldTemplates, newTemplates);
}

export const getGridDataForImportAndCreateStrategy = (gridData) => {
  const { oldTemplates, newTemplates } = gridData;

  return {
    oldTemplates: oldTemplates.map(({ instance_id, w, h, y, x }) => ({ instance_id, w, h, y, x })),
    newTemplate: (({ w, h, y, x }) => ({ w, h, y, x }))(newTemplates[0]),
  }
}

export const getLayoutInfo = () => {
  const grid = $("#template-group-preview");
  const customerId = grid.attr("data-customer-id");
  const id = grid.attr("data-layout-id");
  const name = grid.attr("data-layout-name");
  const perPage = $('input[name="per_page"]').val()

  return { id, customerId, name, perPage };
}

/**
 * @param {{data: FigmaRootContainer, absoluteFileName: string? }[]} filesDTO
 * @returns {Promise<void>}
 */
export const createTemplatesFromFIG = async (filesDTO) => {
  const { id, customerId } = getLayoutInfo();
  const newTemplatesSettings = []

  for (const fileDTO of filesDTO) {
    const {
      data,
      absoluteFilename = null
    } = fileDTO;
    const templates = extractTemplatesFromTree(data.tree);

    for (const template of templates) {
      const gridData = getDataGrid([{
        width: template.data.boundingBox.width,
        height: template.data.boundingBox.height
      }]);

      const sourceFile = absoluteFilename?.match(/user-folder\/(\d+)\/user-files/)
        ? absoluteFilename
        : null;

      const response = await TemplateService.createTemplate(customerId, id, {
        width: template.data.boundingBox.width,
        height: template.data.boundingBox.height,
        name: template.data.name,
        layers: extractLayersFromTree(template.children),
        gridData: getGridDataForImportAndCreateStrategy(gridData),
        sourceFile: sourceFile,
        type: 'FIG'
      });

      const { templateSettings } = response.data;
      newTemplatesSettings.push(templateSettings);
    }
  }

  await LayoutService.updateLayoutSettings(customerId, id, newTemplatesSettings);
  
  Route.deleteParam(ACTION_IMPORT_FROM_PRESELECTED_FIG);
  localStorage.removeItem(ACTION_IMPORT_FROM_PRESELECTED_FIG);
  
  Route.reload();
}
